import { DisplayData } from "./types";
import { ImageType, useCatalogData } from "./process";
// 引入字体、颜色
import "../../theme/aurora.color.css";
import styled from "styled-components";

export interface RendererProps {
  value?: DisplayData;
  imageType?: ImageType;
}

const CatalogWrap = styled.div`
  width: auto;
  max-width: 1184px;
  display: flex;
  gap: 24px;
  flex-direction: column;
  padding: 32px 48px;
  margin: 0 auto;
  @media screen and (width < 600px) {
    padding: 0 32px;
    padding-top: 32px;
    padding-bottom: 64px;
  }
`;

export const CatalogRenderer = ({
  value,
  imageType = "base64",
}: RendererProps) => {
  const data = useCatalogData(value, imageType);
  return (
    <table className="catalog-render-wrap">
      <CatalogWrap className="catalog-render-wrap-render">{data}</CatalogWrap>
    </table>
  );
};
